import React, { useEffect, useState } from 'react';
import { useUserContext } from '../../context/users/UserContext';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaExclamationTriangle, FaTimes } from 'react-icons/fa';

const AlertComponent = () => {
  const { 
    message, 
    msgType, 
    link = false, 
    url, 
    showAlert, 
    disableAlert 
  } = useUserContext();

  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (showAlert) {
      setIsVisible(true);
      setIsExiting(false);
      
      // Auto-dismiss después de 5 segundos
      const autoDismissTimer = setTimeout(() => {
        handleClose();
      }, 5000);
      
      return () => clearTimeout(autoDismissTimer);
    }
  }, [showAlert]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      disableAlert();
    }, 300);
  };

  const getIcon = () => {
    switch (msgType) {
      case 'success':
        return <FaCheckCircle className="alert-icon" />;
      case 'danger':
        return <FaExclamationCircle className="alert-icon" />;
      case 'warning':
        return <FaExclamationTriangle className="alert-icon" />;
      case 'info':
      default:
        return <FaInfoCircle className="alert-icon" />;
    }
  };

  if (!isVisible) return null;

  const alertClass = `alert-banner alert-${msgType}${isExiting ? ' alert-exit' : ''}`;

  return (
    <div className={alertClass} role="alert">
      <div className="alert-content">
        {getIcon()}
        <span className="alert-message">
          {message}
          {link && (
            <a 
              href={url}
              className="alert-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Encuesta
            </a>
          )}
        </span>
        <button 
          type="button" 
          className="alert-close" 
          onClick={handleClose}
          aria-label="Cerrar notificación"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default AlertComponent;
